module.exports = __webpack_public_path__ + "img/48.11.21ac635d.png";